import React from 'react'

const About = () => {
    return (
        <>
            {/* <!-- ============================ -->
  <!-- BANNER -->
  <!-- ============================ --> */}
            <section class="banner header_height about_banner">
                <div class="container dark_bg">
                    <div class="right">
                        <h1 class="headline bold ">About Us</h1>
                        <p>We're not just a dating app. We are your personalized matchmaker. At Peck, we're dedicated to creating an
                            inclusive platform for singles from all walks of life. Join us and embark on a journey of love, laughter, and
                            lasting connections. Because at Peck, we believe everyone deserves someone that matches their vibe.</p>
                        <div class="button_holder">
                            <a href="https://qrcodes.pro/YwhMm2" class="bttn mt2">
                                Download Now
                            </a>
                        </div>
                    </div>
                </div>
                <figure class="left bg_img icon">
                    <img src="images/birds_group.png" alt="" />
                </figure>
                <figure class="bg_img cover">
                    <img src="images/about_bg.png" alt="" />
                </figure>
            </section>
            {/* <!-- === -->

  <!-- ============================ -->
  <!-- OUR TEAM -->
  <!-- ============================ --> */}
            <section class="team space8" id="team">
                <div class="wrap ">
                    <div class="container wider">
                        <div class="main_title_block">
                            <h2 class="mainheadline text_violet bold">
                                Team
                            </h2>
                        </div>
                        <div class="flex_box short_container">
                            <div class="team_image_group">
                                <ul>
                                    <li class="team1 active">
                                        <div class="flipped_wrap">
                                            <figure><img src="images/team1.png" alt="" /></figure>
                                            <div class=" letter_spacing cnt tablet_visible">
                                                <h2 class="headline semibold">Vijith Nair </h2>
                                                <span class="position subtext">Chief Executive Officer</span>
                                            </div>
                                            <div class="flipped_cnt letter_spacing tablet_visible">
                                                <p>Vijith believes in purpose-driven brand-building anchored on trust. He is also the CEO of
                                                    FlipTree.
                                                    Prior to FlipTree, Vijith was an executive at Bank of America, and did management consulting at EY
                                                    and IBM. Vijith has an MBA from Duke University.</p>
                                                <a href="https://www.linkedin.com/in/vijithnair/" class="inside_single_icon">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="team3">
                                        <div class="flipped_wrap">
                                            <figure><img src="images/team3.jpg" alt="" /></figure>
                                            <div class=" letter_spacing cnt tablet_visible">

                                                <h2 class="headline semibold">Shanu V Shaji </h2>
                                                <span class="position subtext">Chief Design Officer</span>
                                            </div>
                                            <div class="flipped_cnt letter_spacing tablet_visible">
                                                <p>Shanu is a designer and a technologist. He has worked extensively on UI/UX, mobile app
                                                    development,
                                                    and platform scalability throughout his career. Shanu’s drive for innovation and creativity is
                                                    evident in everything we do. Shanu has a BE from Anna University.</p>
                                                <a href="https://www.linkedin.com/in/shanu-v-shaji-46b24a125/" class="inside_single_icon">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                </a>
                                            </div>
                                        </div>

                                    </li>
                                    <li class="team2">
                                        <div class="flipped_wrap">
                                            <figure><img src="images/team2.jpg" alt="" /></figure>
                                            <div class=" letter_spacing cnt tablet_visible">

                                                <h2 class="headline semibold">Gayati J Elenjikal </h2>
                                                <span class="position subtext">Chief Marketing Officer</span>
                                            </div>
                                            <div class="flipped_cnt letter_spacing tablet_visible">
                                                <p>Gayati is a designer, digital artist, and marketing strategist with a passion for sketching,
                                                    movies, trends, and customer experience. Over the years Gayati has overseen the launch of various
                                                    consumer product lines. Her spontaneous and spirited ideas are evident in everything we do. Gayati
                                                    has a BA from Pearl Academy.</p>
                                                <a href="https://www.linkedin.com/in/gayati-j-e-320862231/" class="inside_single_icon">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="team4">
                                        <div class="flipped_wrap">
                                            <figure><img src="images/team4.png" alt="" /></figure>
                                            <div class=" letter_spacing cnt tablet_visible">

                                                <h2 class="headline semibold">Urvish Patel</h2>
                                                <span class="position subtext">Chief Technology officer</span>
                                            </div>
                                            <div class="flipped_cnt letter_spacing tablet_visible">
                                                <p>
                                                    Urvish, a seasoned technology executive, excels in optimizing
                                                    technology solutions and processes, bolstering IT operations, security, and service delivery. With
                                                    a robust background in product development and scalability, Urvish's proficiency drives
                                                    accelerated product delivery. Urvish has an MSC from KSV University, India.
                                                </p>
                                                <a href="https://www.linkedin.com/in/patel-urvish-8b846636" class="inside_single_icon">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="team5">
                                        <div class="flipped_wrap">
                                            <figure><img src="images/team5.png" alt="" /></figure>
                                            <div class=" letter_spacing cnt tablet_visible">

                                                <h2 class="headline semibold">Syamjith Sasidharan</h2>
                                                <span class="position subtext">Chief Architect</span>
                                            </div>
                                            <div class="flipped_cnt letter_spacing tablet_visible">
                                                <p>
                                                    Syamjith is a dynamic tech leader skilled in devising and executing
                                                    cutting-edge solutions. He is proficient in enterprise architecture, agile, data analytics, and
                                                    DevOps. Syamjith's cloud prowess fuels our speed-to-market approach. Syamjith has a BCA from Mahatma
                                                    Gandhi University, India.
                                                </p>
                                                <a href="https://www.linkedin.com/in/syamjithas" class="inside_single_icon">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="team6">
                                        <div class="flipped_wrap">
                                            <figure><img src="images/team6.png" alt="" /></figure>
                                            <div class=" letter_spacing cnt tablet_visible">

                                                <h2 class="headline semibold">Jeev George</h2>
                                                <span class="position subtext">Chief Product Officer</span>
                                            </div>
                                            <div class="flipped_cnt letter_spacing tablet_visible">
                                                <p>
                                                    Jeev is a customer-centric product management leader with a keen
                                                    focus on market opportunities and product development. He excels in evaluating and enhancing
                                                    product performance and customer experiences. Jeev has an MBA from Bharathiar University, India
                                                </p>
                                                <a href="https://www.linkedin.com/in/jeev-george-8790341b2" class="inside_single_icon">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="navigate_content_block">
                                <ul class="content_group">
                                    <li class="cnt_body team1 active">
                                        <div class="title_block">
                                            <h3 class="headline  mb4">
                                                Vijith Nair
                                            </h3>
                                            <span class=" subtext uppercase">
                                                Chief Executive Officer
                                            </span>
                                        </div>
                                        <div class="cnt lg letter_spacing match-height">
                                            <p>Vijith believes in purpose-driven brand-building anchored on trust. He is also the CEO of FlipTree.
                                                Prior to FlipTree, Vijith was an executive at Bank of America, and did management consulting at EY
                                                and IBM. Vijith has an MBA from Duke University.</p>
                                            <div class="button_holder">
                                                <a class="bttn icon" href="https://www.linkedin.com/in/vijithnair/">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                    <span>Connect</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="cnt_body team2">
                                        <div class="title_block">
                                            <h3 class="headline semibold mb4">
                                                Gayati J Elenjikal
                                            </h3>
                                            <span class=" subtext uppercase">
                                                Chief Marketing Officer
                                            </span>
                                        </div>
                                        <div class="cnt lg letter_spacing match-height">
                                            <p>Gayati is a designer, digital artist, and marketing strategist with a passion for sketching,
                                                movies, trends, and customer experience. Over the years Gayati has overseen the launch of various
                                                consumer product lines. Her spontaneous and spirited ideas are evident in everything we do. Gayati
                                                has a BA from Pearl Academy.</p>
                                            <div class="button_holder">
                                                <a class="bttn icon" href="https://www.linkedin.com/in/gayati-j-e-320862231/">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                    <span>Connect</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="cnt_body team3">
                                        <div class="title_block">
                                            <h3 class="headline semibold mb4">
                                                Shanu V Shaji
                                            </h3>
                                            <span class=" subtext uppercase">
                                                Chief Design Officer
                                            </span>
                                        </div>
                                        <div class="cnt lg letter_spacing match-height">
                                            <p>Shanu is a designer and a technologist. He has worked extensively on UI/UX, mobile app development,
                                                and platform scalability throughout his career. Shanu’s drive for innovation and creativity is
                                                evident in everything we do. Shanu has a BE from Anna University.</p>
                                            <div class="button_holder">
                                                <a class="bttn icon" href="https://www.linkedin.com/in/shanu-v-shaji-46b24a125/">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                    <span>Connect</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="cnt_body team4">
                                        <div class="title_block">
                                            <h3 class="headline semibold mb4">
                                                Urvish Patel
                                            </h3>
                                            <span class=" subtext uppercase">
                                                Chief Technology officer
                                            </span>
                                        </div>
                                        <div class="cnt lg letter_spacing match-height">
                                            <p>
                                                Urvish, a seasoned technology executive, excels in optimizing
                                                technology solutions and processes, bolstering IT operations, security, and service delivery. With
                                                a robust background in product development and scalability, Urvish's proficiency drives
                                                accelerated product delivery. Urvish has an Msc from KSV University, India.
                                            </p>
                                            <div class="button_holder">
                                                <a class="bttn icon" href="https://www.linkedin.com/in/patel-urvish-8b846636">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                    <span>Connect</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    {/* <!-- shyam --> */}
                                    <li class="cnt_body team5">
                                        <div class="title_block">
                                            <h3 class="headline semibold mb4">
                                                Syamjith Sasidharan
                                            </h3>
                                            <span class=" subtext uppercase">
                                                Chief Architect
                                            </span>
                                        </div>
                                        <div class="cnt lg letter_spacing match-height">
                                            <p>
                                                Syamjith is a dynamic tech leader skilled in devising and executing
                                                cutting-edge solutions. He is proficient in enterprise architecture, agile, data analytics, and
                                                DevOps. Syamjith's cloud prowess fuels our speed-to-market approach. Syamjith has a BCA from Mahatma
                                                Gandhi University, India.
                                            </p>
                                            <div class="button_holder">
                                                <a class="bttn icon" href="https://www.linkedin.com/in/syamjithas">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                    <span>Connect</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    {/* <!-- jeev --> */}
                                    <li class="cnt_body team6">
                                        <div class="title_block">
                                            <h3 class="headline semibold mb4">
                                                Jeev George
                                            </h3>
                                            <span class=" subtext uppercase">
                                                Chief Product Officer
                                            </span>
                                        </div>
                                        <div class="cnt lg letter_spacing match-height">
                                            <p>
                                                Jeev is a customer-centric product management leader with a keen
                                                focus on market opportunities and product development. He excels in evaluating and enhancing
                                                product performance and customer experiences. Jeev has an MBA from Bharathiar University, India
                                            </p>
                                            <div class="button_holder">
                                                <a class="bttn icon" href="https://www.linkedin.com/in/jeev-george-8790341b2">
                                                    <img src="images/linkedin_icon_white.svg" alt="" />
                                                    <span>Connect</span>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul class="team_navigate desktop_visible owl-carousel">
                                    <li><a href="#" target="team1" data-team="team1" class="active"><img src="images/team1.png" alt="" />
                                        <div class="bottom_block">
                                            <span class="bold">
                                                Vijith Nair
                                            </span>
                                            <span class="position">Chief Executive Officer</span>
                                        </div>
                                    </a></li>
                                    <li><a href="#" target="team3" data-team="team3"><img src="images/team3.jpg" alt="" />
                                        <div class="bottom_block">
                                            <span class="bold">Shanu V Shaji</span> <span class="position">Chief Design Officer</span>
                                        </div>
                                    </a></li>
                                    <li><a href="#" target="team2" data-team="team2"><img src="images/team2.jpg" alt="" />
                                        <div class="bottom_block">
                                            <span class="bold">Gayati J Elenjikal</span> <span class="position">Chief Marketing Officer</span>
                                        </div>
                                    </a></li>
                                    <li><a href="#" target="team4" data-team="team4"><img src="images/team4.png" alt="" />
                                        <div class="bottom_block">
                                            <span class="bold">Urvish Patel</span> <span class="position">Chief Technology officer</span>
                                        </div>
                                    </a></li>
                                    <li><a href="#" target="team5" data-team="team5"><img src="images/team5.png" alt="" />
                                        <div class="bottom_block">
                                            <span class="bold">Syamjith Sasidharan</span> <span class="position">Chief Architect</span>
                                        </div>
                                    </a></li>
                                    <li><a href="#" target="team6" data-team="team6"><img src="images/team6.png" alt="" />
                                        <div class="bottom_block">
                                            <span class="bold">Jeev George</span> <span class="position">Chief Product Officer</span>
                                        </div>
                                    </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <figure class="bg_img bg">
                        <img src="images/vector_img.svg" alt="" />
                    </figure>
                    <figure class="bg_img bg2">
                        <img src="images/bg_1.png" alt="" />
                    </figure>
                    <figure class="bg_img feather1 icon">
                        <img src="images/feather1.png" alt="" />
                    </figure>
                    <figure class="bg_img feather3 lg icon">
                        <img src="images/feather3.png" alt="" />
                    </figure>
                    </div>
            </section>
            {/* <!-- === --> */}
        </>
    )
}

export default About